// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3ejlZ","icon":"SortAdornment_icon__1Pxat","up":"SortAdornment_up__2BJnP","down":"SortAdornment_down__15Cl-","active":"SortAdornment_active__24Opl"};